import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { shiftMessage } from 'actionCreators/messages';
import WarningIcon from '@material-ui/icons/Warning';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import SnackbarContent from '@material-ui/core/SnackbarContent';

import './styles.css';

interface IPropsFromConnect {
  messages: any;
  shiftMessage: any;
}

interface IState {
  isOpen: boolean;
  text: string;
  variant: string;
}

class Toast extends PureComponent<IPropsFromConnect, IState> {
  private variantIcons = {
    success: CheckCircleIcon,
    error: ErrorIcon,
    warning: WarningIcon,
    info: InfoIcon
  };

  constructor(props: IPropsFromConnect) {
    super(props);

    this.state = {
      isOpen: false,
      text: '',
      variant: ''
    };
  }

  componentDidUpdate(prevProps: IPropsFromConnect, prevState: IState) {
    if (!prevProps.messages.length && this.props.messages.length && !prevState.isOpen) {
      this.setMessage();
    }
  }

  setMessage = () => {
    const { text, variant } = this.props.messages[0];

    this.setState({
      isOpen: true,
      text,
      variant
    });
  };

  processQueue = () => {
    this.setState({
      isOpen: false
    });

    setTimeout(async () => {
      await this.props.shiftMessage();

      if (this.props.messages.length) {
        this.setMessage();
      }
    }, 500);
  };

  handleClose = (event: any, reason: any = '') => {
    if (reason !== 'clickaway') {
      this.processQueue();
    }
  };

  render() {
    const Icon = this.variantIcons[this.state.variant];

    return (
      <Snackbar
        className="toast-root"
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        open={this.state.isOpen}
        autoHideDuration={2000}
        onClose={this.handleClose}
      >
        <SnackbarContent
          className={this.state.variant}
          message={
            <span className="toast-message">
              {!!Icon && <Icon className="toast-icon" />}
              {this.state.text}
            </span>
          }
          action={
            [
              <IconButton key="close" color="inherit" onClick={this.handleClose}>
                <CloseIcon />
              </IconButton>
            ] as any
          }
        />
      </Snackbar>
    );
  }
}

const mapStateToProps = (state: any) => ({
  messages: state.messages
});

export default connect(mapStateToProps, { shiftMessage })(Toast);
